import Icon from '../Icon.vue'

Icon.register({
  'pause': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M18 10a8.001 8.001 0 00-16 0 8.001 8.001 0 0016 0zm2 0c0 5.522-4.478 10-10 10S0 15.522 0 10 4.478 0 10 0s10 4.478 10 10z'
      },
      {
        d: 'M8 7a1 1 0 011 1v4a1 1 0 11-2 0V8a1 1 0 011-1zM12 7a1 1 0 011 1v4a1 1 0 11-2 0V8a1 1 0 011-1z'
      }
    ]
  }
})
